import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { ExternalLink as ExternalLinkIcon } from 'react-feather';
import {
  Button,
  Link,
  Typography,
  Grid,
} from '@material-ui/core';

import useStyles from './styles';

function Header({
  className,
  supermarket,
  productDescription,
  productBrand,
  sku,
  url,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justifyContent="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          {productDescription}
        </Typography>
        <Typography
          variant="h5"
          color="textSecondary"
        >
          {supermarket} - {productBrand} - SKU: {sku}
        </Typography>
        {url && (
          <Link
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            variant="body1"
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            Ver producto en {supermarket}
            <ExternalLinkIcon size={16} style={{ marginLeft: 6 }} />
          </Link>
        )}
      </Grid>
      <Grid item>
        <Button
          component={RouterLink}
          to="/datos/productsnapshots"
        >
          Volver
        </Button>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  supermarket: PropTypes.string,
  productDescription: PropTypes.string,
  productBrand: PropTypes.string,
  sku: PropTypes.string,
  url: PropTypes.string,
};

export default Header;
